import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

type ExportOption = 'PDF' | 'CSV' | 'Excel' | 'Graph';

interface ExportButtonProps {
  onSelect: (option: ExportOption) => void;
  buttonWidth?: string | number;
  borderRadius?: string | number;
  hideText?: boolean;
}

const ExportButton: React.FC<ExportButtonProps> = ({
  onSelect,
  buttonWidth,
  borderRadius,
  hideText,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (option?: ExportOption) => {
    if (option) onSelect(option);
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        variant="contained"
        className={`btn btn_primary ${hideText ? 'svg_none' : ''}`}
        startIcon={<FileDownloadIcon />}
        onClick={handleClick}
        sx={{
          borderRadius: borderRadius || '20px',
          textTransform: 'none',
          px: 2,
          width: buttonWidth,
        }}
      >
        {hideText ? null : 'Export'}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={() => handleClose()} className="exportMenu">
        {['PDF', 'CSV', 'Excel', 'Graph'].map((option) => (
          <MenuItem key={option} onClick={() => handleClose(option as ExportOption)}>
            {option}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ExportButton;
